<template>

	<transition name="fade">
		<div class="loading" v-show="visible">
			<div v-show="loading">
				<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="40px"
					height="40px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50" xml:space="preserve">
					<path fill="#ffffff"
						d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z"
						transform="rotate(275.098 25 25)">
						<animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25"
							to="360 25 25" dur="0.6s" repeatCount="indefinite"></animateTransform>
					</path>
				</svg>
				<br />
			</div>
			{{content}}
		</div>
	</transition>

</template>

<script>
	export default {
		name: "Toast",
		data() {
			return {
				visible: false,
				content: '',
				duration: 2000,
				loading: false,
				timer: null,
			};
		},
		created() {},
		computed: {},
		methods: {
			show(param) {
				this.visible = true
				document.body.appendChild(this.$el)
				if (typeof(param) == 'object') {
					param = Object.assign({
						content: '加载中...',
						duration: 2000,
						loading: false,
					}, param)
					this.content = param.content
					this.duration = param.duration
					this.loading = param.loading
				} else if (typeof(param) == 'string') {
					this.content = param
					this.duration = 2000
					this.loading = false
				}

				clearTimeout(this.timer)
				this.timer = setTimeout(() => {
					this.visible = false
					this.duration = 2000
					this.loading = false
					//this.content = ''
					//document.body.removeChild(this.$el)
				}, this.duration)
			},
			hide() {
				this.visible = false
				document.body.removeChild(this.$el)
			}
		},
	};
</script>
<style scoped>
	.loading {
		position: fixed;
		left: 50%;
		top: 50%;
		background-color: rgba(0, 0, 0, 0.7);
		color: white;
		transform: translate(-50%, -50%);
		text-align: center;
		max-width: 300px;
		z-index: 99999999999;
		display: inline-block;
		padding: 4px 10px;
		border-radius: 4px;
	}

	.fade-enter-active,
	.fade-leave-active {
		transition: opacity .5s;
	}

	.fade-enter,
	.fade-leave-to {
		opacity: 0;
	}
</style>
